import { WebLink } from '@news-mono/web-common'
import React, { useState } from 'react'
import { TrackerProps } from '../../types'
import { UpdateSchedule } from '../shared/UpdateSchedule'
import { ActiveCasesTable } from './ActiveCasesTable'
import {
    StyledFlexColumn,
    StyledGridItem,
    StyledJabTrackerContainer,
    StyledJabTrackWrap,
    StyledLink,
    StyledSyringeImg,
    StyledTitleGridItem,
    StyledUpdateLink,
} from './JabTracker.styled'
import { TotalCases } from './TotalCases'

const syringeImg = require('./assets/syringe.png')

export function PNJabTracker({
    containerRatios,
    isLoading,
    type,
    data,
}: TrackerProps) {
    const [scheduleOpen, setScheduleOpen] = useState(false)

    return (
        <StyledJabTrackWrap>
            <StyledJabTrackerContainer
                type={type}
                isLoading={isLoading}
                containerRatios={containerRatios}
            >
                <StyledTitleGridItem type={type}>
                    <div>
                        <h3>COVID-19 TRACKER</h3>
                        <p>
                            <span>active cases</span>
                            <span> Local active cases as of today</span>
                        </p>
                    </div>
                    <div className="StyledTitleGridItem--total-case-wrap">
                        {data && <TotalCases type={type} data={data && data} />}
                    </div>
                    <StyledSyringeImg src={syringeImg} alt="Covid syringe" />
                </StyledTitleGridItem>

                <StyledGridItem>
                    {data && <ActiveCasesTable type={type} data={data} />}
                </StyledGridItem>
                <StyledFlexColumn>
                    <StyledLink>
                        Source:
                        <WebLink to="https://covidlive.com.au">
                            covidlive.com.au
                        </WebLink>
                    </StyledLink>
                    <StyledUpdateLink
                        onClick={() => setScheduleOpen(true)}
                        isOpen={scheduleOpen}
                    >
                        View update schedule
                    </StyledUpdateLink>
                </StyledFlexColumn>
            </StyledJabTrackerContainer>
            <UpdateSchedule
                isOpen={scheduleOpen}
                setScheduleOpen={setScheduleOpen}
            />
        </StyledJabTrackWrap>
    )
}
